import { ChangeEvent, ChangeEventHandler } from "react";
import styles from "./TextField.module.css";

interface TextFieldProps {
  label?: "view" | "none";
  placeholder?: string;
  disabled?: boolean;
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  id?: string;
  height?: number | string;
  name: string;
  labelText?: string;
  isRequired?: boolean;
  error?: boolean;
  errorText?: string;
  instanceInput?: boolean;
  /** Sag icte kucuk spinner gosterir (canli uygunluk kontrolu surerken). */
  loading?: boolean;
  /** Yesil cerceve + successText etiketi (hesap adi kullanilabilir durumu). */
  success?: boolean;
  successText?: string;
}

const TextField = (props: TextFieldProps) => {
  const { label, placeholder, onChange, name, labelText, isRequired, error, errorText, instanceInput, loading, success, successText } = props;

  const handleChange: ChangeEventHandler<HTMLInputElement> | undefined = (e) => {
    if (!instanceInput) {
      onChange(e);
      return;
    }

    const charMap: Record<string, string> = {
      'ş': 's', 'Ş': 's',
      'ç': 'c', 'Ç': 'c',
      'ğ': 'g', 'Ğ': 'g',
      'ü': 'u', 'Ü': 'u',
      'ö': 'o', 'Ö': 'o',
      'ı': 'i', 'İ': 'i',
    };

    e.target.value = e.target.value
      .split('')
      .map(char => charMap[char] || char)
      .join('')
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, '')
      .replace(/^-+/, '')
      .replace(/--+/g, '-')
      .slice(0, 30);

    onChange(e);
  };

  return (
    <div className={styles.textFieldWrapper}>
      {label === "view" &&
        <label htmlFor="">
          {labelText}
          {isRequired ? <span style={{ color: 'red' }}> *</span> : ''}
        </label>
      }
      <div className={styles.inputBox}>
        <input
          id={props.id}
          type="text"
          name={name}
          disabled={props.disabled}
          placeholder={placeholder}
          value={props.value}
          className={error ? styles.inputError : success ? styles.inputSuccess : undefined}
          style={{ height: props.height ? props.height : '' }}
          onChange={handleChange}
        />
        {loading && <span className={styles.inputSpinner} aria-hidden="true"></span>}
      </div>
      {error && <label style={{ color: 'red', fontSize: '14px' }}>{errorText}</label>}
      {!error && success && successText && <label style={{ color: '#16a34a', fontSize: '14px' }}>{successText}</label>}
    </div>
  );
};

export default TextField;
